export default __webpack_public_path__ + "static/media/sensus-communis-logo.c5e63430.svg";